/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import AppRouterDefinition from "../../../AppRouterDefinition";
import VertialSplit from "./../../../Basis/Components/VerticalSplit";

const EMailprofileView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */"../Views/EMailprofileView"));
const EMailprofileNavigationView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Views/EMailprofileNavigationView"));
const EMailprofilView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Views/EMailprofilView"));
const EMailprofilDetailsView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Views/EMailprofilDetailsView"));
const EMailprofileBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Components/EMailprofileBreadcrumb"));
const EMailprofilBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Components/EMailprofilBreadcrumb"));
const ZertifikateBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Components/ZertifikateBreadcrumb"));
const ZertifikatBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Components/ZertifikatBreadcrumb"));
const ZertifikatsfelderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Components/ZertifikatsfelderBreadcrumb"));
const ZertifikatsfeldBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Components/ZertifikatsfeldBreadcrumb"));
const ZertifikatsfeldDetailsView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Views/ZertifikatsfeldDetailsView"));
const ZertifikatsfeldView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Views/ZertifikatsfeldView"));
const ZertifikatsfelderNavigationView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Views/ZertifikatsfelderNavigationView"));
const ZertifikatsfelderView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Views/ZertifikatsfelderView"));
const ZertifikatView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Views/ZertifikatView"));
const ZertifikatDetailsView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Views/ZertifikatDetailsView"));
const ZertifikateNavigationView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Views/ZertifikateNavigationView"));
const ZertifikateView = React.lazy(() => import(/* webpackChunkName: "Dokumente" */ "../Views/ZertifikateView"));

const E_MAILPROFILE_PATH = "/emailprofile";
const E_MAILPROFIL_PATH = "/emailprofil/:eMailprofilId";
const ZERTIFIKATEPATH = "/zertifikate";
const ZERTIFIKATPATH = "/zertifikat/:zertifikatId";
export const dokumenteRouterDefinitons: Array<AppRouterDefinition> = [
    {
        path: E_MAILPROFILE_PATH,
        render: () => <EMailprofileView />,
        createBreadcrumbs: () => [<EMailprofileBreadcrumb />],
    },
    {
        path: E_MAILPROFIL_PATH,
        render: (props) => (
            <VertialSplit
                right={() => <EMailprofilView {...props} />}
                left={() => <EMailprofileNavigationView {...props} />}
            />
        ),
        createBreadcrumbs: (props) => [
            <EMailprofileBreadcrumb />,
            <EMailprofilBreadcrumb eMailprofilId={props.eMailprofilId} />,
        ],
    },
    {
        exact: true,
        path: E_MAILPROFIL_PATH,
        parentPath: E_MAILPROFIL_PATH,
        render: (props) => <EMailprofilDetailsView {...props} />,
        createBreadcrumbs: (props) => [
            <EMailprofileBreadcrumb />,
            <EMailprofilBreadcrumb eMailprofilId={props.eMailprofilId} />,
        ],
    },
    {
        path: ZERTIFIKATEPATH,
        render: () => <ZertifikateView />,
        createBreadcrumbs: () => [<ZertifikateBreadcrumb />],
    },
    {
        path: ZERTIFIKATPATH,
        render: (props) => (
            <VertialSplit
                right={() => <ZertifikatView {...props} />}
                left={() => <ZertifikateNavigationView {...props} />}
            />
        ),
        createBreadcrumbs: (props) => [
            <ZertifikateBreadcrumb />,
            <ZertifikatBreadcrumb zertifikatId={props.zertifikatId} />,
        ],
    },
    {
        exact: true,
        path: ZERTIFIKATPATH,
        parentPath: ZERTIFIKATPATH,
        render: (props) => <ZertifikatDetailsView {...props} />,
        createBreadcrumbs: (props) => [
            <ZertifikateBreadcrumb />,
            <ZertifikatBreadcrumb zertifikatId={props.zertifikatId} />,
        ],
    },
    {
        exact: true,
        path: `${ZERTIFIKATPATH}/felder`,
        parentPath: ZERTIFIKATPATH,
        render: (props) => <ZertifikatsfelderView {...props} />,
        createBreadcrumbs: (props) => [
            <ZertifikateBreadcrumb />,
            <ZertifikatBreadcrumb zertifikatId={props.zertifikatId} />,
            <ZertifikatsfelderBreadcrumb zertifikatId={props.zertifikatId} />,
        ],
    },
    {
        path: `${ZERTIFIKATPATH}/feld/:zertifikatsfeldId`,
        render: (props) => (
            <VertialSplit
                right={() => <ZertifikatsfeldView {...props} />}
                left={() => <ZertifikatsfelderNavigationView {...props} />}
            />
        ),
        createBreadcrumbs: (props) => [
            <ZertifikateBreadcrumb />,
            <ZertifikatBreadcrumb zertifikatId={props.zertifikatId} />,
            <ZertifikatsfelderBreadcrumb zertifikatId={props.zertifikatId} />,
            <ZertifikatsfeldBreadcrumb zertifikatId={props.zertifikatId} zertifikatsfeldId={props.zertifikatsfeldId} />
        ],
    },
    {
        exact: true,
        path: `${ZERTIFIKATPATH}/feld/:zertifikatsfeldId`,
        parentPath: `${ZERTIFIKATPATH}/feld/:zertifikatsfeldId`,
        render: (props) => <ZertifikatsfeldDetailsView {...props} />,
        createBreadcrumbs: (props) => [
            <ZertifikateBreadcrumb />,
            <ZertifikatBreadcrumb zertifikatId={props.zertifikatId} />,
            <ZertifikatsfelderBreadcrumb zertifikatId={props.zertifikatId} />,
            <ZertifikatsfeldBreadcrumb zertifikatId={props.zertifikatId} zertifikatsfeldId={props.zertifikatsfeldId} />
        ],
    },
];
